import { PropertyLeadProfile } from '../property-lead-profile/property-lead-profile';
import { RealtorProfile } from '../realtor-profile/realtor-profile';

export class OwnerLeadProfile
{
	ownerLeadProfileId: number;
	ownerLeadProfileDate: Date;
	propertyLeadProfiles: PropertyLeadProfile[];
	ownerLeadProfiles: RealtorProfile[];
	assignToSalesAgnt1: UserSummary;
	assignToSalesAgnt2: UserSummary;
	assignToSalesAgnt3: UserSummary;
	assignToSalesAgnt4: UserSummary;
	assignToMgr: UserSummary;
	createDate: string;
	lastUpdate: string;

  emailAddress: string;
  mobilePhone: string;
  phone2: string;
  fullName: string;
  firstName: string;
  lastName: string;
  subjAdrStreet: string;
  mailAdrStreet: string;
  mailAdrStreet2: string;
  mailAdrCity: string;
  mailAdrState: string;
  mailAdrCountry: string;
  mailAdrPostalCode: string;
  unitNumber: string;
  leadStatus: string;
  referralFeePaymentDate: string | Date | null;
  compContractExpDate: string | Date | null;


}

export class UserSummary
{
	summary: string;
	firstName: string;
	lastName: string;
	companyName: string;
}
